<div class="container-fluid admin-form-page">
  <app-page-header heading="Create new Entity" subHeading="Add Entity details to create listing"></app-page-header>
  <div class="section1">
    @if (isError) {
      <div class="alert alert-danger alert-dismissible fade show" style="margin:10px 0;cursor: pointer;"
        role="alert">
        <span>{{errMessage}}</span>
      </div>
    }
    <div class="applicants-details details1 admin-form-card">
      <div class="admin-form">
        <div class="row">
          <div class="col-12 job-form">
            <div class="col-md-12 top">
              <mat-horizontal-stepper class="example-stepper" labelPosition="bottom"
                [linear]="true" #stepper [selectedIndex]="activeTab">
                <!--      STEP-1  -->
                <mat-step label="Basic Info ">
                  <div class="col-md-12 step-card">
                    <div class="row">
                      <div class="col-12">
                        <form class="admin-form" ngNativeValidate name="basicInfoFrom" (ngSubmit)="next()">
                          <div class="row align-items-center">
                            <div class="col-1 ">
                              <div class="user-form">
                                <div class="form-group d-flex flex-column">
                                  <label class="text-nowrap">Choose Profile*</label>
                                  @if (payload.image) {
                                    <img class="position-relative rounded-circle"
                                      style="object-fit: cover" width="100" height="100"
                                      src="{{payload.image}}" alt="">
                                  }
                                  @if (!payload.image) {
                                    <img class="position-relative rounded-circle"
                                      style="object-fit: cover" width="100"
                                      height="100"
                                      src="assets/images/placeholder.png" alt="">
                                    }
                                    @if (!payload.image && !uploading) {
                                      <i (click)="handleClickUpload()"
                                      class="las font-size-16 la-plus-circle img-icon"></i>
                                    }
                                    @if (payload.image && !uploading) {
                                      <i (click)="handleClickUpload()"
                                      class="las font-size-16 la-pencil-alt img-icon"></i>
                                    }
                                    @if (uploading) {
                                      <div class="img-icon-loader">
                                        <img src="assets/images/loading.gif" width="40" alt="">
                                      </div>
                                    }
                                  </div>
                                  <input id="dp_entity" name="file-upload-field" type="file"
                                    accept=".png, .jpg, .jpeg, .webp"
                                    class="form-control d-none"
                                    (change)="fileChangeEvent($event, imageCropperModal)">
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="user-form">
                                  <div class="form-group">
                                    <label>First Name*</label>
                                    <input type="text" class="form-control" required id="f-name" name="first-name"
                                      [(ngModel)]="payload.firstName" placeholder="Enter First Name">
                                  </div>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="user-form">
                                  <div class="form-group">
                                    <label>Last Name</label>
                                    <input type="text" class="form-control" id="l-name" name="last-name"
                                      [(ngModel)]="payload.lastName" placeholder="Enter Last Name">
                                  </div>
                                </div>
                              </div>
                              <div class="col-3">
                                <div class="user-form">
                                  <div class="form-group">
                                    <label>Is Person ?*</label>
                                    <select id="followable" class="form-control" name="isPerson"
                                      [(ngModel)]="payload.in_person">
                                      <option [value]="true">Yes</option>
                                      <option [value]="false">No</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="user-form">
                                  <div class="form-group">
                                    <label>Date*</label>
                                    <input type="date" class="form-control" required id="ent-date" name="entity-date"
                                      [(ngModel)]="payload.date" placeholder="Enter Date">
                                  </div>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="user-form">
                                  <div class="form-group">
                                    <label>Label*</label>
                                    <input type="text" class="form-control" required id="e-label" name="entity-label"
                                      [(ngModel)]="payload.label" placeholder="Enter Label">
                                  </div>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="user-form">
                                  <div class="form-group">
                                    <label>Category*</label>
                                    <ng-select class="custom"
                                      [(ngModel)]="payload.category"
                                      name="category"
                                      id="category"
                                      (change)="onOptionsSelected($event); findCategory($event)"
                                      notFoundText="No category found"
                                      placeholder="Select category"
                                      [clearable]="false">
                                      @for (category of categoryList; track category) {
                                        <ng-option
                                        [value]="category.id">{{category.categoryName}}</ng-option>
                                      }
                                    </ng-select>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="p-2 mt-5">
                              <div class="stepper-buttons">
                                <button class="btn btn-info" type="reset">Reset</button>
                                <button class="btn btn-sm btn-primary btn-dashboard"  type="submit">Next</button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </mat-step>

                  <!--      STEP-2  -->
                  <mat-step label="Info Params">
                    <div class="col-md-12 step-card">
                      <form class="admin-form" ngNativeValidate name="basicInfoFrom" (ngSubmit)="next()">
                        <div class="row">
                          @for (info of informativeParameters; track info; let i = $index) {
                            <div class="col-12 form-details1">
                              <div class="user-form">
                                <div class="form-group">
                                  <label>{{info.fieldName + (info.isRequired ? '*' : '')}}</label>
                                  <div>
                                    @switch (info.fieldType) {
                                      @case ('text') {
                                        <div>
                                          <input type="text" class="form-control" [name]="info.id"
                                            [(ngModel)]="payload.infoData[i]['value']" [required]="info.isRequired"
                                            placeholder="{{info.fieldName}}">
                                        </div>
                                      }
                                      @case ('date') {
                                        <div>
                                          <input type="date" class="form-control" [name]="info.id" [required]="info.isRequired"
                                            [(ngModel)]="payload.infoData[i]['value']" [id]="info.id"
                                            [placeholder]="info.fieldName">
                                        </div>
                                      }
                                      @case ('text-area') {
                                        <div>
                                          <angular-editor [placeholder]="info.fieldName" [config]="editorConfig" rows="6"
                                            [name]="info.id" [(ngModel)]="payload.infoData[i]['value']"
                                          [required]="info.isRequired" [id]="info.id"></angular-editor>
                                        </div>
                                      }
                                      @case ('lookUp') {
                                        <div>
                                          <!--<select [id]="info.id" [name]="info.id" [(ngModel)]="payload.infoData[i]['metadata']"
                                          class="form-control" (ngModelChange)="payload.infoData[i]['value'] = $event.id">
                                          <option selected disabled>&#45;&#45;Select Entity&#45;&#45;</option>
                                          <option *ngFor="let e of info.lookupEntities"
                                            [ngValue]="{id: e.id, slug: e.slug, name: e.firstName + ' ' + e.lastName}">
                                          {{e.firstName}} {{e.lastName}}</option>
                                        </select>-->
                                        <ng-select class="custom"
                                          [(ngModel)]="payload.infoData[i]['metadata']"
                                          [name]="'lookUp'+info.fieldName"
                                          [id]="'lookUp'+info.fieldName"
                                          (change)="payload.infoData[i]['value'] = $event.id"
                                          [notFoundText]="'No '+ info.fieldName + ' found'"
                                          [placeholder]="'Select ' + info.fieldName "
                                          [clearable]="false">
                                          @for (e of filterEntities(info.lookUpRecordId); track e) {
                                            <ng-option
                                              [value]="{id: e.id, slug: e.slug, name: e.firstName + ' ' + e.lastName}">
                                              {{e.firstName}} {{e.lastName}}
                                            </ng-option>
                                          }
                                        </ng-select>
                                      </div>
                                    }
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                      @if (informativeParameters.length == 0) {
                        <div class="mat-card no-results-card">
                          <div class="mat-card-header">
                            <div class="mat-card-title">No Info-params Found</div>
                          </div>
                          <div class="mat-card-content">
                            <p>Sorry, we couldn't find any informative parameters matching your selected category.</p>
                            <small>(Please click on NEXT to got o next step)</small>
                          </div>
                        </div>
                      }
                      <div class="p-2 mt-5">
                        <div class="stepper-buttons">
                          <button class="btn btn-info" matStepperPrevious>Prev</button>
                          <button class="btn btn-sm btn-primary btn-dashboard" type="submit">Next</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </mat-step>

                <!--      STEP-3  -->
                <mat-step label="Subjective Params">
                  <div class="col-md-12 step-card">
                    <form class="admin-form" ngNativeValidate name="basicInfoFrom" (ngSubmit)="next()">
                      <div class="row">
                        @for (sub of subjectiveParameters; track sub; let si = $index) {
                          <div class="col-12 col-lg-3 col-xl-3 form-details1"
                            >
                            <div class="user-form">
                              <div class="form-group">
                                <h4>{{sub.fieldName}}</h4>
                                <angular-editor placeholder="Enter your text here" [config]="editorConfig" [name]="sub.id"
                                [(ngModel)]="payload.subjectiveData[si]" required></angular-editor>
                              </div>
                            </div>
                          </div>
                        }
                        @if (subjectiveParameters.length == 0) {
                          <div class="mat-card no-results-card">
                            <div class="mat-card-header">
                              <div class="mat-card-title">No Sub-params Found</div>
                            </div>
                            <div class="mat-card-content">
                              <p>Sorry, we couldn't find any subjective parameters matching your selected category.</p>
                              <small>(Please click on SUBMIT to create entity)</small>
                            </div>
                          </div>
                        }
                      </div>
                      <div class="p-2 mt-5">
                        <div class="stepper-buttons">
                          <button class="btn btn-info" matStepperPrevious>Prev</button>
                          <button class="btn btn-sm btn-primary btn-dashboard"  type="submit">Next</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </mat-step>

                <!--      STEP-4  -->
                <mat-step label="Feature Accessibility">
                  <div class="col-md-12 step-card">
                    <form class="admin-form" ngNativeValidate name="basicInfoFrom" (ngSubmit)="createEntity()">
                      <div class="col-12 form-group px-0">
                        <div class="row justify-content-between">
                          <h4>Accessibility</h4>
                        </div>
                        <div class="row">
                          @for (x of payload.allowedUserActions | keyvalue; track x; let xi = $index) {
                            <div class="col-auto">
                              <label class="mr-2">{{x.key}}</label>
                              <input type="checkbox" [(ngModel)]="payload.allowedUserActions[x.key]"
                                name="checkboxName-{{xi}}"
                                id="checkboxId-{{xi}}">
                            </div>
                          }
                        </div>
                      </div>
                      <div class="p-2 mt-5">
                        <div class="stepper-buttons">
                          <button class="btn btn-info" matStepperPrevious>Prev</button>
                          <button class="btn btn-sm btn-primary btn-dashboard"  type="submit" [disabled]="loading">
                            {{loading ? 'Please wait...' : 'Submit'}}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </mat-step>
              </mat-horizontal-stepper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #imageCropperModal>
  <div class="modal-header">
    <h5 class="modal-title">Profile image</h5>
    <button type="button" class="close " data-dismiss="modal" aria-label="Close" (click)="closeCropperModal()" [disabled]="uploading">
      <span aria-hidden="true" class="">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <image-cropper
      (imageCropped)="imageCropped($event)"
      (loadImageFailed)="loadImageFailed()"
      output="blob"
      [aspectRatio]=aspectRatio
      [imageChangedEvent]="imageChangedEvent"
      [maintainAspectRatio]="true"
      format="png">
    </image-cropper>
  </div>
  <div class="modal-footer justify-content-end">
    <button type="button" class="btn btn-default mr-2" data-dismiss="modal" (click)="closeCropperModal()" [disabled]="uploading">Close</button>
    <button (click)="uploadImage()" class="btn btn-primary btn-dashboard" type="button" [disabled]="uploading">
      {{uploading ? 'Uploading...' : 'Crop'}}
    </button>
  </div>
</ng-template>
